

export const btnRendererComplete = {
    template: `
      <span  v-if="params.data.registerStatus === 'NO_TEST' ">
        <button color="primary"  class="btn-sm btn-primary ">Complete</button>
      </span>
    `
}

export const btnRendererZoomAcceptRequest = {
    template: `<span v-if="params.data.registerStatus != 'INACTIVE'">
                    <button class="btn-sm btn-secondary">Req Zoom Accept</button>
                </span>`
}
export const btnCreateAssign = {
    template: `<span >
                    <button color="primary"  class="btn-sm btn-primary ">Create Assign</button>
               </span>`
}
